const applySlashURL = (...args: string[]) => {
  if (!args[0]) return "";
  const result = args
    .map((arg, i) => {
      const cleanedArg = arg.replace(/^\/+/, "");
      if (i === 0) {
        if (arg.endsWith("/") || arg.includes("?")) {
          return arg;
        }

        return arg + "/";
      }

      if (cleanedArg.endsWith("/") || cleanedArg.includes("?")) {
        return cleanedArg;
      }

      return cleanedArg + "/";
    })
    .join("");

  // Replace multiple slashes with single slash, except in protocol (http:// or https://)
  return result.replace(
    /(https?:\/\/)|(\/)+/g,
    (_match, protocol) => protocol || "/",
  );
};

export default applySlashURL;